const setSortingParameterAndType = ({ commit }, data) => {
    commit("SET_SORTING_PARAMETER", data.param);
    if (data.type) {
        commit("SET_SORTING_TYPE", data.type)
    } else {
        commit("SET_SORTING_TYPE", 'asc')
    }

};

const setSearchParameter = ({ commit }, param) => {
    commit("SET_SEARCH_PARAMETER", param);
};

const setFilterParameter = ({ commit }, param) => {
    commit("SET_FILTER_PARAMETER", param);
};
const setSecondFilterParameter = ({ commit }, param) => {
    commit("SET_SECOND_FILTER_PARAMETER", param);
};

const setNullToAllParameters = ({ commit }) => {
    commit('SET_SORTING_PARAMETER', null);
    commit('SET_SORTING_TYPE', null)
    commit('SET_FILTER_PARAMETER', null)
    commit('SET_SEARCH_PARAMETER', null)
    commit('SET_SECOND_FILTER_PARAMETER', null)
}

export default {
    setSortingParameterAndType,
    setSearchParameter,
    setFilterParameter,
    setSecondFilterParameter,
    setNullToAllParameters
};
